module.exports = __webpack_public_path__ + "static/img/normal-temperature-delivery.39bd25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/2/normal-temperature-delivery.png
// module id = Vght
// module chunks = 1